<div *ngIf="global.globalAgencyId==null || global.globalAgencyId==undefined ||global.globalAgencyId=='00000000-0000-0000-0000-000000000000' || global.globalAgencyId=='' ">
    <div class="row mt-4 ">
        <div class="col ">
            <div widget class="card border-0 box-shadow">
                <div class="card-body  widget-body pt-2">
                    <div class="text-center text-danger">
                        <label class="font-red animate-charcter"><i class="fa fa-info-circle fa-lg"></i>&nbsp;Select
                            agency to view
                            details</label>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div *ngIf="global.globalAgencyId!=null && global.globalAgencyId!=undefined  &&
global.globalAgencyId!=''&& global.globalAgencyId!='00000000-0000-0000-0000-000000000000'">
  <div class="col-12" *ngIf="!ProspectiveCreate">
    <h4 class="mb-2 font-header-1">Referral</h4>
  </div>
  
  <div *ngIf="!ClientIntakeCreate">
    <div class="row mt-4" *ngIf="global.globalAgencyId">
      <div class="col">
        <div class="card border-0 shadow">
          <div class="card-body">
            <div class="row g-3 mt-2">

              <div class="col-lg-3 mt-5">
                <label class="fw-bold me-3">
                  <input type="radio" value="UNDER"   [(ngModel)]="referralAge"
                          (click)="RBO.referralAge = 'UNDER';referralstartDate='';referralendDate='';referralAge='UNDER';" >
                         Below 24 hrs
              </label>
              <label class="fw-bold">
                <input type="radio" value="OVER"   [(ngModel)]="referralAge"
                       (click)="RBO.referralAge = 'OVER';referralAge='OVER'" >
                       Over 24 hrs
            </label>
              </div>
              <!-- Start Date -->
              <div class="col-lg-3">
                <label class="fw-bold">Start Date  <sup class="text-danger" *ngIf="shouldShowDateAsterisk()">*</sup></label>
                <my-date-picker [options]="myDatePickerOptionsDOB" placeholder="mm/dd/yyyy" [selDate]="referralstartDate"
                  (inputFieldChanged)="newdates($event, 'inputchanged', 'Startdate')" [disabled]="referralAge == 'UNDER'"
                  (dateChanged)="newdates($event, 'datechanged', 'Startdate')">
                </my-date-picker>
              </div>

              <!-- End Date -->
              <div class="col-lg-3">
                <label class="fw-bold">End Date  <sup class="text-danger" *ngIf="shouldShowDateAsterisk()">*</sup></label>
                <my-date-picker [disabled]="!referralstartDate" [options]="myDatePickerOptionsDOB" placeholder="mm/dd/yyyy"
                  [selDate]="referralendDate" (inputFieldChanged)="newdates($event, 'inputchanged', 'Enddate')"
                  (dateChanged)="newdates($event, 'datechanged', 'Enddate')" [disabled]="referralAge == 'UNDER'">
                </my-date-picker>
              </div>

              <!-- Location -->
              <div class="col-lg-3">
                <label class="fw-bold">Referral Status</label>
              <ng-select [(ngModel)]="RBO.ReferralStatusLid" [items]="statusList" bindLabel="lovName" bindValue="id"
                [searchable]="true" [clearable]="true">
              </ng-select>
              </div>

              <!-- Location -->
              <div class="col-lg-3">
                <label class="fw-bold">Location</label>
                <ng-select [(ngModel)]="RBO.locationId" [items]="getLocationList" bindLabel="Value" bindValue="Key"
                [searchable]="true" [clearable]="true">
              </ng-select>
            </div>
            <div class="col-lg-3">

              <label class="fw-bold">Language</label>
  
              <ng-select [(ngModel)]="RBO.languageLIds" [searchable]="true"
                [clearable]="true" [multiple]="true" [items]="languageList" bindLabel="lovName"
                bindValue="id" name="languageIds" 
                 >
  
              </ng-select>
            </div>
            
            <!-- client search -->
            <div class="col-lg-3">
              <label class="fw-bold">Client Name/Medicaid</label>
              <div class="d-flex">
                <input type="text" [(ngModel)]="clientName" class="form-control" placeholder="Search Client/Medicaid" (keyup.enter)="ApplyFilter()">
                <i class="fa fa-search mt-2 ms-1" for="inputGroupSelect02" (click)="ApplyFilter()"></i>
              </div>
            </div>
            
         
            
            </div>

            <div class="row g-3 mt-3">
              <div class="col-lg-8">
                <button type="button" class="btn btn-primary btn-sm" (click)="CreateNewIntake()"
                  *ngIf="fp.referralcreate">
                  Create Referral
                </button>
              </div>

              <div class="col-lg-4 text-end">
                <!-- <button type="button" class="btn btn-primary btn-sm me-2"
                [disabled]="(referralAge === 'OVER' && (!referralstartDate || !referralendDate))"
                (click)="ApplyFilter()">
                  Apply
                </button> -->
                <button type="button" class="btn btn-primary btn-sm me-2"
  [disabled]="isApplyFilterDisabled()"
  (click)="ApplyFilter()">
  Apply
</button>
                <button type="button" class="btn btn-primary btn-sm " (click)="RefreshIntake()"
                  [disabled]="!global.globalAgencyId">
                  <i class="fa fa-repeat"></i> Refresh
                </button>
              </div>
            </div>

            <div class="row mt-3">
              <div class="col-12">
 <!-- 
                   When adding/removing columns to this grid:
                   1. Update ReferralTotalColumns constant in referral.component.ts
                   2. This prevents localStorage persistence conflicts
                   3. Grid ID 'Referral' maps to localStorage key 'gridReferral'
                                                                          -->               
                <ejs-grid #gridProspective  id="referralGrid" [dataSource]="Prospectivedata | async" [allowSorting]="true" 
                 [allowReordering]="true" 
                  [enablePersistence]="true"
                  [allowResizing]="true" *ngIf="global.globalAgencyId" (resizeStop)="onResize($event)"
                  [allowPaging]="true" [pageSettings]="initialPage" [filterSettings]="filterSettings"
                  [allowFiltering]="true" (actionBegin)="onActionComplete($event)" [showColumnChooser]="true"
                  (dataStateChange)="dataStateChange($event)">
                  <e-columns>
                    <e-column minWidth="100" uid="action" headerText="Actions" [showInColumnChooser]="false"
                      class="text-center">
                      <ng-template #template let-data>

                        <button *ngIf="data.referralStatus == 'Pending'|| data.referralStatus == 'PENDING' && fp.referraledit"
                          class="btn btn-sm btn-outline-primary"
                          (click)="isEditGridValues(data); selectProspectivedetails(data);isrejectreason=false">
                          <i class="fa fa-edit"></i>
                        </button>
                        <button *ngIf="data.referralStatus != 'Pending'&& data.referralStatus != 'PENDING'"
                          class="btn btn-sm btn-outline-secondary"
                          (click)="isViewGridValues(); selectProspectivedetails(data);">
                          <i class="fa fa-eye"></i>
                        </button>
                          <button *ngIf="data.referralStatus == 'Pending'|| data.referralStatus == 'PENDING'&& fp.referraldelete"
                          class=" btn btn-delete-table ms-3" (click)="getDeleteId(data)">
                          <i class="fa fa-trash"></i>
                        </button>
                      </ng-template>
                    </e-column>
                    <e-column minWidth="100" field="clientName" headerText="Client Name" type="string">
                      <ng-template #filterTemplate let-data>
                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                      </ng-template>
                    </e-column>
                    <e-column minWidth="100" field="phone1" headerText="Client Phone" type="string">
                      <ng-template #filterTemplate let-data>
                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                      </ng-template>
                    </e-column>
                    <e-column minWidth="100" field="email" headerText="Email" type="string">
                      <ng-template #filterTemplate let-data>
                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                      </ng-template>
                    </e-column>
                    <e-column minWidth="100" field="languagesList" headerText="Language" type="string" [allowSorting]="false" [allowFiltering]="false">
                      <ng-template #filterTemplate let-data>
                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                      </ng-template>
                    </e-column>
                    <e-column minWidth="100" field="medicaid" headerText="Medicaid (PMI)" type="string">
                      <ng-template #filterTemplate let-data>
                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                      </ng-template>
                    </e-column>
                    <e-column minWidth="100" field="referralStartTime" headerText="Referral Date" type="date"
                      [format]="formatOptions">
                    </e-column>
                    <e-column minWidth="100" field="referralAge" headerText="Referral Age" type="string" [allowSorting]="false" [allowFiltering]="false">
                      <ng-template #filterTemplate let-data>
                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                      </ng-template>
                    </e-column>
                    <e-column minWidth="100" field="referralStatus" headerText="Referral Status" type="string">
                      <ng-template #filterTemplate let-data>
                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                      </ng-template>
                    </e-column>
                    <e-column minWidth="100" field="locationCode" headerText="Location" type="string">
                      <ng-template #filterTemplate let-data>
                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                      </ng-template>
                    </e-column>
                    <e-column minWidth="100" field="lastAssessmentDate" headerText="Last Assessment Date"
                      [format]="formatOptions1" type='date'>
                    </e-column>

                    <e-column width="50" [showInColumnChooser]="false">
                      <ng-template #headerTemplate let-data>
                        <div class="d-none d-lg-block">
                          <span id="show" (click)="show()">
                            <i class="fa fa-cog fa-lg" aria-hidden="true"></i>
                          </span>
                        </div>
                      </ng-template>
                    </e-column>
                  </e-columns>
                </ejs-grid>
                <!-- 
                   When adding/removing columns to this grid:
                  1. Update ReferralTotalColumns constant in referral.component.ts
                  2. This prevents localStorage persistence conflicts
                  3. Grid ID 'Referral' maps to localStorage key 'gridReferral'
                                                                          -->
              </div>
            </div>

            <div *ngIf="ProspectiveList.length == 0 && global.globalAgencyId" class="text-center text-danger">
              <p>No data available</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row mb-3" *ngIf="ProspectiveCreate">
    <div class="col-lg-6 ps-3">

      <h4 class="mb-0 font-header-1" *ngIf="saveBo.id=='00000000-0000-0000-0000-000000000000'"
        style="font-weight: 700;"><label (click)="alertMessageModal()"><i class="fa fa-chevron-circle-left"
            title="Close" style="font-size:24px"></i></label>&nbsp;Create Referral</h4>

      <h4 class="mb-0 font-header-1" *ngIf="saveBo.id!='00000000-0000-0000-0000-000000000000'"
        style="font-weight: 700;"><label (click)="alertMessageModal()"><i class="fa fa-chevron-circle-left"
            title="Close" style="font-size:24px"></i></label>&nbsp;Update Referral</h4>
    </div>
    <div class="col-lg-6 text-end mb-2">
      <button (click)="printIntakeforms()" class="me-4  btn blue-btn btn-sm" style="float:right"> <i
          class="fa fa-print"> </i>Print</button>

      <button type="button" class="btn  btn-sm me-2"
        *ngIf="saveBo.id=='00000000-0000-0000-0000-000000000000' " [hidden]="isApprovedRejectedFields"
        [disabled]="!ReferralForm.valid" (click)="SaveOrUpdateIntakeClientDetails(); isonboard=false;isreject=false;">Save
      </button>

      <button type="button" class="btn  btn-sm me-2"
        *ngIf="saveBo.id!='00000000-0000-0000-0000-000000000000'&& fp.referralupdate "
        [hidden]="isApprovedRejectedFields" [disabled]="!ReferralForm.valid"
        (click)="SaveOrUpdateIntakeClientDetails();isonboard=false;isreject=false;">Update</button>

      <button type="button" class="btn  btn-sm me-2" style="background-color: green;" *ngIf="fp.referralonboard"
        [hidden]="isApprovedRejectedFields" [disabled]="isViewApproveRejected" (click)="onboardclient()" 
        >Onboard</button>

      <button type="button" class="btn btn-sm me-2" style="background-color: red;" [hidden]="isApprovedRejectedFields"
        *ngIf="fp.referralreject" [disabled]="isViewApproveRejected" (click)="RejectIntakeProcess()">Reject</button>




    </div>
  </div>
  <div *ngIf="ProspectiveCreate" >
  <div class="mt-2 p-0 mb-2">
    <div class="col p-0">
      <div widget class="card border-0 box-shadow" style="min-height: 500px;">
        <div class="row">
          <div class="col-lg-12 col-md-12">
            <nav>
              <div class="nav nav-tabs nav-fill " id="nav-tab" role="tablist">

                <!-- Notes -->
                <a class="nav-item nav-link " id="nav-notes-tab" data-bs-toggle="tab" href="#nav-notes" role="tab"
                  [ngClass]="{ 'disabled' : global.referralId == '00000000-0000-0000-0000-000000000000','mytab-inactive':ActiveTab!='nav-notes','active':ActiveTab=='nav-notes' }"
                  aria-controls="nav-notes" aria-selected="true"
                  (click)="getTabActiveData('nav-notes');isNotes=true">Notes</a>
                  
                  <a class="nav-item nav-link active" id="nav-general-tab" data-bs-toggle="tab" href="#nav-general"
                  role="tab"
                  [ngClass]="{ 'mytab-inactive':ActiveTab!='nav-general','active':ActiveTab=='nav-general' }"
                  aria-controls="nav-general" aria-selected="true" (click)="getTabActiveData('nav-general')">General</a>
                  <a class="nav-item nav-link " id="nav-contacts-tab" data-bs-toggle="tab"
                  href="#nav-contacts" role="tab"
                  [ngClass]="{'disabled' : global.referralId == '00000000-0000-0000-0000-000000000000', 'mytab-inactive':ActiveTab!='nav-contacts','active':ActiveTab=='nav-contacts'}"
                  aria-controls="nav-contacts" aria-selected="false"
                  (click)="getTabActiveData('nav-contacts');isEnabledcontact=true">Contacts</a>
                </div>
            </nav>
              <!-- Create Prospective ClientIntakeForm -->
 <!--------------------------- General----------- ------------------->
 <div *ngIf="ActiveTab=='nav-general'">
  <div class="tab-pane fade  " id="nav-general" role="tabpanel" aria-labelledby="nav-general"
    [ngClass]="{'active':ActiveTab=='nav-general','show':ActiveTab=='nav-general'}">
    <div class="row mb-2">
      <div class="col ps-0">
    <!-- ------------General Info-------------------- -->
    <div class="card-header transparent text-muted ms-2  me-3 mt-2">
      <div class="row">
        <div class="col-lg-6">
          <h5 class="mb-0 font-header-green">General Info</h5>
        </div>
      </div>
    </div>

    <div class="card-body widget-body pt-2 ms-2  me-3">
      <div class="row">
        <div class="col-lg-12">
          <div class="row" [formGroup]="ReferralForm">
            <div class="col-lg-6 col-md-6 d-inline-flex ">
              <label class=" me-1 label-normal w-75">First Name<sup class="super-script">*</sup></label>
              <input type="text" class="form-control w-100" name="firstName" [(ngModel)]="saveBo.firstName" (ngModelChange)="changeFunction()"
                formControlName="firstName" id="fname" />
            </div>
            <div class="col-lg-6 col-md-6 d-inline-flex ">
              <label class=" me-1 label-normal  w-75">Middle
                Name</label>
              <input type="text" class="form-control w-100" name="middleName" formControlName="middleName" (ngModelChange)="changeFunction()"
                [(ngModel)]="saveBo.middleName">
            </div>
          </div>
          <div class="row mt-2" [formGroup]="ReferralForm">
            <div class="col-lg-6 col-md-6 d-inline-flex">
              <label class=" me-1 label-normal  w-75">Last Name<sup class="super-script">*</sup></label>
              <input type="text" class="form-control w-100" name="lastName" [(ngModel)]="saveBo.lastName" (ngModelChange)="changeFunction()"
                formControlName="lastName">
            </div>

            <div class="col-lg-6 col-md-6 d-inline-flex">
              <label class=" me-1 label-normal  w-75">DOB<sup class="super-script">*</sup></label>
              <my-date-picker class="w-100" placeholder="mm/dd/yyyy" name="dOB" id="dob" [selDate]="saveBo.dOB" (ngModelChange)="changeFunction()"
                [options]="myDatePickerOptionsDOB" (inputFieldChanged)="DOBdatechange($event)" formControlName="dob"
                (dateChanged)="onDateChanged($event)"></my-date-picker>

            </div>

          </div>
          <div class="row mt-1">
            <div class="col-lg-6 col-md-6 d-inline-flex" [formGroup]="ReferralForm">
              <label class=" me-1 label-normal  w-75">Gender<sup class="super-script">*</sup></label>

              <ng-select class="w-100" [(ngModel)]="saveBo.genderLid" formControlName="genderLid" [searchable]="true" (ngModelChange)="changeFunction();bindprint();"
                [clearable]="true" [items]="genderList" bindLabel="lovName" name="genderLid" bindValue="id">
              </ng-select>
            </div>
            <div class="col-lg-6 col-md-6 d-inline-flex">
              <label class="me-1 label-normal w-75">Age</label>
              <input type="text" class="form-control w-100" name="age" [(ngModel)]="saveBo.age" disabled>
            </div>
          </div>
          <div class="row mt-1">
            <div class="col-lg-6 col-md-6 d-inline-flex" [formGroup]="ReferralForm">
              <label class="me-1 label-normal w-75">Medicaid# (PMI)<sup class="super-script">*</sup></label>
              <input type="text" class="form-control w-100" name="medicaid" [(ngModel)]="saveBo.medicaid"  (ngModelChange)="changeFunction()"
                 (keypress)="keyPress($event)" formControlName="medicaid" id="ClientEditmedicaid" />
            </div>
            <div class="col-lg-6 col-md-6 d-inline-flex" [formGroup]="ReferralForm">
              <label class="me-1 label-normal w-75">Medicare#</label>
              <input type="text" class="form-control w-100" name="medicare" [(ngModel)]="saveBo.medicare" (ngModelChange)="changeFunction()"
                maxlength="20" (keypress)="keyPress($event)" formControlName="medicare" id="ClientEditmedicare" />
            </div>
          </div>
          <div class="row mt-1">
            <div class="col-lg-6">
              <span
                *ngIf="ReferralForm.controls['medicaid'].touched && ReferralForm.controls['medicaid'].invalid">
                <p class="text-danger">Invalid Medicaid# </p>
              </span>
            </div>           
          </div>

          <div class="row mt-1">
            <div class="col-lg-6 col-md-6 d-inline-flex" [formGroup]="ReferralForm">
              <label class="me-1 label-normal w-75">Language</label>

              <ng-select class="w-100" [(ngModel)]="selectedLanguages" [searchable]="true" [clearable]="true" (ngModelChange)="changeFunction();bindprint();"
                [multiple]="true" [items]="languageList" bindLabel="lovName" bindValue="id" name="languageIds"
                 formControlName="language">

              </ng-select>
            </div>
            <div class="col-lg-6 col-md-6 d-inline-flex" [formGroup]="ReferralForm">
              <label class="me-1 label-normal w-75">Type of Waiver</label>

              <ng-select class="w-100" [(ngModel)]="saveBo.typeofWaiverLid" [searchable]="true" [clearable]="true" (ngModelChange)="changeFunction();bindprint();"
                [items]="TypeofWaiver" bindLabel="lovName" bindValue="id" formControlName="typeofWaiverLid">

              </ng-select>



            </div>
          </div>
          <div class="row mt-1">
            <div class="col-lg-6 col-md-6 d-inline-flex" [formGroup]="ReferralForm">
              <label class=" me-1 label-normal  w-75">Client Insurance ID</label>
              <input type="text" class="form-control w-100" name="insuranceNo" [(ngModel)]="saveBo.insuranceNo" (ngModelChange)="changeFunction()"
                formControlName="insuranceNo" (keypress)="keyPress($event)" minlength="5" maxlength="20" />
            </div>
            <div class="col-lg-6 col-md-6 d-inline-flex" [formGroup]="ReferralForm">
              <label class=" me-1 label-normal  w-75">CFSS Model</label>

              <ng-select class="w-100" [(ngModel)]="saveBo.cfssModel" [searchable]="true" [clearable]="true"
                [items]="cfssModel" formControlName="cfssModel"(ngModelChange)="changeFunction()" >
              </ng-select>
            </div>
          </div>
          <div class="row mt-1">
            <div class="col-lg-6">
              <span
                *ngIf="ReferralForm.controls['insuranceNo'].touched && ReferralForm.controls['insuranceNo'].invalid">
                <p class="text-danger">Invalid Client Insurance ID </p>
              </span>
            </div>           
          </div>
          <div class="row mt-1">

            <div class="col-lg-6 col-md-6 d-inline-flex" [formGroup]="ReferralForm">
              <label class="me-1 label-normal w-75">Pay Source</label>

              <ng-select class="w-100" [(ngModel)]="saveBo.paySourceLid" [searchable]="true" [clearable]="true"
                [items]="PaySourceitem" bindLabel="lovName" bindValue="id" name="PaySourceName"(ngModelChange)="changeFunction();bindprint();"
                formControlName="PaySourceLid">

              </ng-select>
            </div>

            <!-- Client Type General -->

            <div class="col-lg-6 col-md-6 d-inline-flex" [formGroup]="ReferralForm">
              <label class="me-1 label-normal w-75">Client Type</label>

              <ng-select class="w-100" [searchable]="true" [clearable]="true" [(ngModel)]="saveBo.clientTypeLid"
                [items]="TypeofClient" bindLabel="lovName" bindValue="id" id="ClientEditclientTypeLid2" (ngModelChange)="changeFunction();bindprint();"
                formControlName="clientTypeLid">
              </ng-select>

            </div>

          </div>

          <div class="row mt-1">

            <div class="col-lg-6 col-md-6 d-inline-flex" [formGroup]="ReferralForm">
              <label class="me-1 label-normal w-75">Referral Date<sup class="super-script">*</sup></label>
              <input type="datetime-local" class="form-control w-100" #editstarttime formControlName="referralStartTime" (ngModelChange)="changeFunction()"
                [(ngModel)]="saveBo.referralStartTime" [max]="currentDateTime" min="1000-01-01T00:00" />
            </div>

            <div class="col-lg-6 col-md-6 d-inline-flex" [formGroup]="ReferralForm">
              <label class="me-1 label-normal w-75">Location<sup class="super-script">*</sup></label>
              <ng-select class="w-100 " [(ngModel)]="saveBo.locationId" formControlName="location" [searchable]="true"
                [clearable]="true" [items]="getLocationList" bindLabel="Value" bindValue="Key"(ngModelChange)="changeFunction();bindprint();" >
              </ng-select>

            </div>

          </div>
        </div>
      </div>
    </div>

    <!------------------------- Contact Info ------------------->
    <div class="card-header transparent text-muted ms-2  me-3">
      <div class="row">
        <div class="col-lg-6">
          <h5 class="mb-0 font-header-green">Contact Info</h5>
        </div>
      </div>
    </div>
    <div class="card-body widget-body pt-2 ms-2  me-3">
      <div class="row">
        <div class="col-lg-12">
          <div class="row mt-1">
            <div class="col-lg-6 col-md-6 d-inline-flex" [formGroup]="ReferralForm">
              <label class=" me-1 label-normal  w-75">Email
                <!-- <sup class="super-script">*</sup> -->
              </label>
              <input type="text" class="form-control w-100" name="email" email="true" formControlName="ClientEmail"
                [(ngModel)]="saveBo.email" (ngModelChange)="changeFunction()"/>

            </div>
            <div class="col-lg-6 col-md-6 d-inline-flex" [formGroup]="ReferralForm">
              <label class=" me-1 label-normal  w-75">Phone 1</label>
              <input type="text" class="form-control w-100" name="phone12" maxlength="14" minlength="14" 
                formControlName="ClientPhone1" [(ngModel)]="saveBo.phone1" (ngModelChange)="DemographicPhoneFormat()"
                (keypress)="keyPress($event)" />
            </div>

          </div>
          <div class="row mt-1">
            <div class="col-lg-6">
              <span
                *ngIf="ReferralForm.controls['ClientEmail'].touched && ReferralForm.controls['ClientEmail'].invalid">
                <p class="text-danger">Enter Valid Mail</p>
              </span>
            </div>
            <div class="col-lg-6">
              <span
                *ngIf="ReferralForm.controls['ClientPhone1'].touched && ReferralForm.controls['ClientPhone1'].invalid">
                <p class="text-danger">Invalid Phone number</p>
              </span>
            </div>
          </div>

          <div class="row mt-1" [formGroup]="ReferralForm">
            <div class="col-lg-6 col-md-6 d-inline-flex">
              <label class=" me-1 label-normal  w-75">Phone 2</label>
              <input type="text" class="form-control w-100" name="phone22" formControlName="ClientPhone2" maxlength="14"
                minlength="14" [(ngModel)]="saveBo.phone2" (ngModelChange)="DemographicPhoneFormat()"
                (keypress)="keyPress($event)" />
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12 mt-2 col-xs-12 d-inline-flex">
              <label class="mr-1 col-lg-5" style="margin-top: 5px;  text-align: left; width: 43%; color: black;">Manual
                Address
              </label>
              <input type="checkbox" [(ngModel)]="saveBo.isHomelessClient" id="ClientEditisHomelessClient" (ngModelChange)="changeFunction()"
                [disabled]="!referralenable" [ngModelOptions]="{standalone: true}">
            </div>
          </div>
          <div class="row mt-1">

            <div class="col-lg-6">
              <span
                *ngIf="ReferralForm.controls['ClientPhone2'].touched && ReferralForm.controls['ClientPhone2'].invalid">
                <p class="text-danger">Invalid Phone number</p>
              </span>
            </div>
          </div>
        </div>

      </div>
      <div class="row mt-2">
        <div class="col-lg-6 col-md-6 d-inline-flex " [formGroup]="ReferralForm">
          <div class="w-75 d-flex justify-content-between align-items-center">
            <label class="me-1 label-normal w-75">Street <sup class="super-script">*</sup></label>
            <button *ngIf="referralenable" type="button " class="btn blue-btn btn-sm mb-2 me-2"
              id="ClientEditAddressGoogleMap" data-bs-target="#SearchAddress" data-bs-toggle="modal"
              (click)="AddressGoogleMap = true"> Address
            </button>
          </div>
          <input type="text" class="form-control w-100 ml-1" name="street" [disabled]=" !saveBo.isHomelessClient" [attr.disabled]="!saveBo.isHomelessClient ? true : null"
            [(ngModel)]="saveBo.street" formControlName="street" id="ClientEditstreet2" (ngModelChange)="changeFunction()">
        </div>
        <div class="col-lg-6 col-md-6 d-inline-flex" [formGroup]="ReferralForm">
          <label class=" me-1 label-normal  w-75">Apt</label>
          <input type="text" class="form-control w-100" name="apt" [(ngModel)]="saveBo.apt" formControlName="apt" (ngModelChange)="changeFunction()" />
        </div>



      </div>
      <div class="row mt-1">


        <div class="col-lg-6 col-md-6 d-inline-flex" [formGroup]="ReferralForm">
          <label class=" me-1 label-normal  w-75">City <sup class="super-script">*</sup></label>
          <input type="text" id="city" class="form-control w-100" id="ClientEditcity2" name="city" [attr.disabled]="!saveBo.isHomelessClient ? true : null"
            [disabled]=" !saveBo.isHomelessClient" [(ngModel)]="saveBo.city" formControlName="city" (ngModelChange)="changeFunction()" />
        </div>
        <div class="col-lg-6 col-md-6 d-inline-flex" [formGroup]="ReferralForm">
          <label class=" me-1 label-normal  w-75">State<sup class="super-script">*</sup></label>
          <ng-select [items]="stateList" id="state" class="w-100 " [searchable]="true" [(ngModel)]="saveBo.state"
            [clearable]="true" bindLabel="name" bindValue="abbreviation" id="ClientEditstatelid" (ngModelChange)="changeFunction()"
            formControlName="state">
          </ng-select>
        </div>

      </div>
      <div class="row mt-1">

        <div class="col-lg-6 col-md-6 d-inline-flex" [formGroup]="ReferralForm">
          <label class=" me-1 label-normal  w-75">ZIP Code<sup class="super-script">*</sup></label>
          <div class="d-inline-flex w-100">
            <input type="text" class="form-control  me-1 w-100" name="zipCode" id="ClientEditzipCode"
              [disabled]="!saveBo.isHomelessClient"  [attr.disabled]="!saveBo.isHomelessClient ? true : null" formControlName="zip" [(ngModel)]="saveBo.zipCode"
              (keypress)="keyPress($event)" minlength="5" maxlength="10" (ngModelChange)="changeFunction()" />
            <button *ngIf="referralenable" type="button " class="btn blue-btn btn-sm " (click)="getzipcodeClient()"
              id="ClientEditgetzipcodeClient" [disabled]="saveBo.state ==null || saveBo.state =='' || saveBo.state ==undefined || saveBo.city ==null || saveBo.city ==''  ||
                      saveBo.city ==undefined">GetZip</button>
          </div>

        </div>
        <div class="col-lg-6 col-md-6 d-inline-flex" [formGroup]="ReferralForm">
          <label class=" me-1 label-normal  w-75">County</label>
          <input type="text" class="form-control w-100" name="county" id="ClientEditcounty" formControlName="county" (ngModelChange)="changeFunction()"
            [disabled]=" !saveBo.isHomelessClient" [attr.disabled]="!saveBo.isHomelessClient ? true : null" [(ngModel)]="saveBo.county">
        </div>

      </div>
      <div class="row mt-2">

        <div class="card-header transparent text-muted mt-3 me-3">
          <div class="row">
            <div class="col-lg-6">
              <h5 class="mb-0 font-header-green">Additional Notes</h5>
            </div>
          </div>
        </div>
        <div class="card-body widget-body pt-2 me-3">

          <div class="row mt-3">
            <div class="col-lg-6 col-md-6 d-inline-flex" [formGroup]="ReferralForm">
              <label class=" me-1 label-normal  w-75">Referrer Name</label>
              <input type="text" class="form-control w-100" name="apt" [(ngModel)]="saveBo.referer_Name"
                formControlName="referrerName"(ngModelChange)="changeFunction()"/>
            </div>

            <div class="col-lg-6 col-md-6 d-inline-flex" [formGroup]="ReferralForm">
              <label class=" me-1 label-normal  w-75">Referrer Phone </label>
              <input type="text" class="form-control w-100" name="referer_PhoneNumber"
                formControlName="referer_PhoneNumber" maxlength="14" minlength="14"
                [(ngModel)]="saveBo.referer_PhoneNumber" (ngModelChange)="DemographicPhoneFormat()"
                (keypress)="keyPress($event)" />
            </div>
          </div>
          <div class="row mt-1">
            <div class="col-lg-6">
            </div>
            <div class="col-lg-6">
              <span
                *ngIf="ReferralForm.controls['referer_PhoneNumber'].touched && ReferralForm.controls['referer_PhoneNumber'].invalid">
                <p class="text-danger">Invalid Phone number</p>
              </span>
            </div>
          </div>
          <div class="row mt-1">
            <div class="col-lg-6 col-md-6 d-inline-flex" [formGroup]="ReferralForm">
              <label class=" me-1 label-normal  w-75">Referrer Email </label>
              <input type="text" class="form-control w-100" name="referer_Email" email="true"
                formControlName="referer_Email" [(ngModel)]="saveBo.referer_Email" (ngModelChange)="changeFunction()" />

            </div>
            <div class="col-lg-6 col-md-6 d-inline-flex" [formGroup]="ReferralForm">
              <label class="me-1 label-normal w-75">Last Assessment Date
              </label>
              <my-date-picker class="w-100" placeholder="mm/dd/yyyy" name="lastAssessmentDate" id="lastAssessmentDate"
                [selDate]="saveBo.lastAssessmentDate" [options]="myDatePickerOptions"
                formControlName="lastAssessmentDate" (ngModelChange)="changeFunction()"
                (inputFieldChanged)="newdates($event ,'inputchanged' ,'lastassessment')"
                (dateChanged)="newdates($event,'datechanged','lastassessment')"></my-date-picker>
            </div>
          </div>
          <div class="row mt-1">
            <div class="col-lg-6">
            </div>
            <div class="col-lg-6" style="text-align: center;">
              <span
                *ngIf="ReferralForm.controls['referer_Email'].touched && ReferralForm.controls['referer_Email'].invalid">
                <p class="text-danger">*Enter Valid Mail</p>
              </span>
            </div>
          </div>
        </div>

        <div class="card-header transparent text-muted   me-3">
          <div class="row">
            <div class="col-lg-6">
              <h5 class="mb-0 font-header-green">Follow Up Notes</h5>
            </div>
          </div>
        </div>

        <div class="card-body widget-body pt-2 ms-2 mt-2  me-3" [formGroup]="ReferralForm">
          <div class="row ms-2">
            <textarea class="form-control " rows="10" cols="100" [(ngModel)]="saveBo.followUpNotes" id="followUpNotes" (input)="adjustTextareaSize($event)"
              formControlName="followupnotes" (ngModelChange)="changeFunction()"></textarea>
          </div>
        </div>
        <!-- <div class="card-header transparent text-muted   me-3" *ngIf="isrejectreason">
          <div class="row">
            <div class="col-lg-6">
              <h5 class="mb-0 font-header-green">Reason For Rejection</h5>
            </div>
          </div>
        </div>
        <div class="card-body widget-body pt-2 ms-2 mt-2  me-3" [formGroup]="ReferralForm" *ngIf="isrejectreason">
          <div class="row ms-2">
            <textarea class="form-control " rows="10" cols="100" [(ngModel)]="saveBo.reasonForRejection"  (input)="adjustTextareaSize($event)"
              formControlName="rfr" ></textarea>
          </div>
        </div>
         -->
      </div>
    </div>
  </div>
  </div>
  </div>
  </div>
  
  <div *ngIf="ActiveTab=='nav-notes'">
    <div class="tab-pane fade  " id="nav-notes" role="tabpanel" aria-labelledby="nav-notes"
      [ngClass]="{'active':ActiveTab=='nav-notes','show':ActiveTab=='nav-notes'}">
      <div class="p-3">
        <app-referral-notes *ngIf="isNotes" [Referral]="saveBo">
        </app-referral-notes>
      </div>
    </div>
  </div>
 
    <!-----------------------------Contact-------------------------------------------------->

    <div *ngIf="ActiveTab=='nav-contacts'">
      <div class="tab-pane fade" id="nav-contacts" role="tabpanel" aria-labelledby="nav-contacts"
        [ngClass]="{'active':ActiveTab=='nav-contacts','show':ActiveTab=='nav-contacts'}">

        <div class="row ml-3 mt-3">
          <div class="row ms-3 mt-3">
            <div class="col-lg-1">
              Filter
            </div>
            <div class="col-lg-2">
              <input type="radio"  name="contacts" id="contacts"
                value="contacts" [(ngModel)]="contactfilter" (change)="callingfunction()">&nbsp; Contacts
            </div>
            <div class="col-lg-2">
              <input type="radio"  name="case" id="case" value="case"
                [(ngModel)]="contactfilter" (change)="callingfunction()"> &nbsp; CaseManagers
            </div>
            <div class="col-lg-2">
              <input type="radio" name="care"  value="care" id="care"
                [(ngModel)]="contactfilter" (change)="callingfunction()"> &nbsp; CareCoordinators
            </div>

          </div>


        </div>

        <div *ngIf="contactfilter == 'contacts'">
          <div class="row  mr-0">
            <div class="col-lg-12 text-right ">
              <button class="btn blue-btn btn-sm" data-bs-toggle="modal" data-bs-target="#modalSaveOrUpdate" [disabled]="global.referralTab"
                 >Add
                Contact</button>
            </div>
          </div>
        </div>
        <app-client-employee-contact [ContactRelation]="ClientEmployeeContact"
        *ngIf="isRelationcontact && contactfilter == 'contacts'">
      </app-client-employee-contact>

        <div *ngIf="contactfilter == 'case'">
          <div class="card-body widget-body pb-0 pt-2 mb-4">
            <div class="row mt-2 mb-2">
              <div class="col-lg-1 ms-2">
                <label>Status</label>
              </div>
              <div class="col-lg-2">
                <!-- <select class="form-select" [(ngModel)]="CaseStatus" (ngModelChange)="getclientCaseLst()" id="getclientCaseLst">
                                  <option  name="lovName" [items]="StatusFilterLst"></option>
                                </select> -->
                <ng-select [clearable]="true" [searchable]="true" [items]="StatusLst" bindLabel="lovName"
                  bindValue="id" [(ngModel)]="CaseStatus" id="getclientCaseLst"
                  (ngModelChange)="getclientCaseLst()">
                </ng-select>
              </div>

              <div class="col-lg-4 ">
                <button class="btn btn-primary btn-sm"
                  (click)="caseenable=false; casetype='edit'; assignCaseManager=null; AssignCaseManagerBoolean=true; getCaseManagerDropdown(); getStatusforCase();"
                  data-bs-toggle="modal" data-bs-target="#casemanager" id="assigncasemanager" [disabled]="global.referralTab">
                  Assign Case Manager
                </button>
                <button class="btn btn-primary btn-sm ms-3 mt-1"
                  (click)="caseenable=true; casetype='view'; AssignCaseManagerBoolean=false" [disabled]="global.referralTab"
                  data-bs-toggle="modal" data-bs-target="#casemanager" id="addcasemanager">
                  Add Case Manager
                </button>
              </div>
            </div>

            <div class="row">
              <ejs-grid #gridcasemanager [dataSource]='Prospectivedata | async' [allowResizing]='true'
                *ngIf="global.globalAgencyId!=0" [allowPaging]='true' [pageSettings]='initialPage'
                (resizeStop)="onResizeCase($event)" (dataStateChange)='dataStateChangeCasemanager($event)'
                (actionBegin)="onActionCompleteCasemanager($event)">

                <e-columns>
                  <e-column minWidth="200" headerText="Actions" uid="action" textAlign="center"
                    [showInColumnChooser]='false'>
                    <ng-template #template let-data>
                      <button class="btn btn-edit-table me-1" (click)="editcasemanager(data)" [disabled]="global.referralTab"
                        id="editcasemanager" data-bs-toggle="modal" data-bs-target="#casemanager">
                        <i class="fa fa-edit"></i>
                      </button>
                      <button class="btn btn-delete-table" (click)="deletecaseId=data.id" id="deletecasemanager" [disabled]="global.referralTab"
                        data-bs-toggle="modal" data-bs-target="#deletecase">
                        <i class="fa fa-trash"></i>
                      </button>
                    </ng-template>
                  </e-column>

                  <e-column minWidth="100" field="caseManagerName" headerText="Name"></e-column>
                  <e-column minWidth="100" field="county" headerText="County"></e-column>
                  <e-column minWidth="100" field="state" headerText="State"></e-column>
                  <e-column minWidth="100" field="city" headerText="City"></e-column>
                  <e-column minWidth="100" field="zip" headerText="Zip"></e-column>
                  <e-column minWidth="100" field="phone" headerText="Telephone"></e-column>
                  <e-column minWidth="100" field="fax" headerText="Fax"></e-column>
                  <e-column minWidth="100" field="alternateFax" headerText="Alternative Fax"></e-column>
                  <e-column minWidth="100" field="email" headerText="Email"></e-column>
                  <e-column minWidth="100" field="statusName" headerText="Status"></e-column>

                  <e-column field="activeDate" headerText="Active Date" minWidth="100" type="datetime"
                    [allowFiltering]="false" [format]='formatOptions'>
                    <ng-template #filterTemplate let-data>
                      <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                  </e-column>

                  <e-column field="inActiveDate" headerText="InActive Date" minWidth="100" type="datetime"
                    [allowFiltering]="false" [format]='formatOptions'>
                    <ng-template #filterTemplate let-data>
                      <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                  </e-column>
                </e-columns>
              </ejs-grid>

              <div class="col-lg-12">
                <div *ngIf="caseLst.length == 0" class="text-center text-danger">
                  <p>No data available</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Care Cordinator -->
        <div *ngIf="contactfilter == 'care'">
          <div class="card-body  widget-body pb-0 pt-2 mb-4">
            <div class="row mt-2 mb-2">
              <div class="col-lg-1 ms-2">
                <label>Status</label>
              </div>
              <div class="col-lg-2">
                <!-- <select class="form-select" [(ngModel)]="CaseStatus" (ngModelChange)="getclientCaseLst()" id="getclientCaseLst">
                                <option  name="lovName" [items]="StatusFilterLst"></option>
                              </select> -->
                <ng-select [clearable]="true" [searchable]="true" [items]="StatusLst" bindLabel="lovName"
                  bindValue="id" [(ngModel)]="CareStatus" (ngModelChange)="getclientCareLst()"
                  id="getclientCareLst">
                </ng-select>
              </div>

              <div class="col-lg-2">
                <button class="btn btn-primary btn-sm" data-bs-toggle="modal" data-bs-target="#carecoordinator"
                  id="assigncarecoordinator" [disabled]="global.referralTab"
                  (click)="careenable=false;caretype='edit';assignCareCoordinator=null;AssignCareCoordinatorBoolean=true;getCareCoordinatordropdown();getStatusforCase()">Assign
                  Care
                  Coordinator</button>
              </div>
              <div class="col-lg-2">
                <button class="btn btn-primary btn-sm ml-3 " data-bs-toggle="modal"
                  data-bs-target="#carecoordinator" id="addcarecoordinator" [disabled]="global.referralTab"
                  (click)="careenable=true;caretype='view';AssignCareCoordinatorBoolean=false">Add
                  Care Coordinator</button>
              </div>

            </div>
            <div class="row">
              <ejs-grid #gridcarecoordinator [dataSource]='datacare | async' [allowResizing]='true'
                allowPaging='true' [pageSettings]='initialPage' (resizeStop)="onResizecare($event)"
                (dataStateChange)='dataStateChangeCare($event)' (actionBegin)="onActionCompleteCare($event)">
                <e-columns>
                  <e-column minWidth=100 headerText="Actions" uid="action" textAlign="center"
                    [showInColumnChooser]='false'>
                    <ng-template #template let-data>
                      <div class="col-lg-2">
                        <button class="btn btn-edit-table mr-1" data-bs-toggle="modal" [disabled]="global.referralTab"
                          (click)="editcaremanager(data)" id="editcarecoordinator"
                          data-bs-target="#carecoordinator"><i class="fa fa-edit"></i></button>&nbsp;
                        <button class="btn btn-delete-table" data-bs-toggle="modal" [disabled]="global.referralTab"
                          (click)="deletecareId=data.id" id="deletecarecoordinator"
                          data-bs-target="#deletecare"><i class="fa fa-trash"></i></button>
                      </div>
                    </ng-template>

                  </e-column>
                  <e-column minWidth=100 field="careCoordinatorName" headerText="Name"></e-column>
                  <e-column minWidth=100 field="county" headerText="County"></e-column>
                  <e-column minWidth=100 field="phoneNumber" headerText="phoneNumber"></e-column>
                  <e-column minWidth=100 field="fax" headerText="Fax"></e-column>
                  <e-column minWidth=100 field="alternateFax" headerText="Alternative Fax"></e-column>
                  <e-column minWidth=100 field="email" headerText="Email"></e-column>
                  <e-column minWidth=100 field="statusName" headerText="Status"></e-column>

                  <e-column field="activeDate" headerText="Active Date" minWidth=100 type="datetime"
                    [allowFiltering]="false" [format]='formatOptions'>
                    <ng-template #filterTemplate let-data>
                      <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                  </e-column>
                  <e-column field="inActiveDate" headerText="InActive Date" minWidth=100 type="datetime"
                    [allowFiltering]="false" [format]='formatOptions'>
                    <ng-template #filterTemplate let-data>
                      <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                  </e-column>

                </e-columns>
              </ejs-grid>
              <div class="col-lg-12">
                <div *ngIf="carecoLst.length == 0" class="text-center" style="color:red">
                  <p>No data available</p>
                </div>
              </div>

            </div>
          </div>
        </div>


      </div>
    </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

  <!-- Approve Modal -->
  <span id="openApprove" data-bs-target="#ApproveModal" data-bs-toggle="modal"></span>
  <div class="modal" id="ApproveModal" data-bs-backdrop="static">
    <div class="modal-dialog modal-md">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">
            <label class="mb-0 fw-bold">Onboard Alert</label>
          </h4>
          <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
        </div>
        <div class="modal-body">
          Are you sure you want to Onboard Referral Client
        </div>
        <div class="modal-footer">
          <button class="btn btn-sm" type="button" data-bs-dismiss="modal"
            (click)="SaveApprovedIntakeClient()">Yes</button>
          <button type="button" class="btn btn-sm" data-bs-dismiss="modal">No</button>
        </div>
      </div>
    </div>
  </div>

  <!-- Reject Modal -->
  <span id="openRejectAlertModal" data-bs-target="#RejectAlertModalClose" data-bs-toggle="modal"></span>
  <div class="modal" id="RejectAlertModalClose" data-bs-backdrop="static">
    <div class="modal-dialog modal-md">
      <div class="modal-content" style="width:530px">
        <div class="modal-header">
          <h4 class="modal-title">
            <label class="mb-0 fw-bold">Reject Alert</label>
          </h4>
          <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-lg-4">
              <label class="mt-4">Reason for Rejection<sup class="text-danger">*</sup></label>
            </div>
            <div class="col-lg-6">
              <textarea class="form-control" style="width: 249px; height: 72px;"
                [(ngModel)]="rejectedItems.reasonForRejection">
            </textarea>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-sm" [disabled]="!rejectedItems.reasonForRejection"
            (click)="ConfirmRejection()">Reject</button>
          <button type="button" class="btn btn-sm" data-bs-dismiss="modal">Cancel</button>
        </div>
      </div>
    </div>
  </div>

  <!-- Close Modal -->
  <span id="openCloseModal" data-bs-target="#CloseModal" data-bs-toggle="modal"></span>
  <div class="modal" id="CloseModal" data-bs-backdrop="static">
    <div class="modal-dialog modal-md">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">Close</h4>
          <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
        </div>
        <div class="modal-body">
          You want to close without save?
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-sm" data-bs-dismiss="modal"
            (click)="closeProspectiveIntakeform()">Yes</button>
          <button type="button" class="btn btn-sm" data-bs-dismiss="modal">No</button>
        </div>
      </div>
    </div>
  </div>

   <!-- Close Modal -->
   <span id="opensaveModal" data-bs-target="#saveModal" data-bs-toggle="modal"></span>
   <div class="modal" id="saveModal" data-bs-backdrop="static">
     <div class="modal-dialog modal-md">
       <div class="modal-content">
         <div class="modal-header">
           <h4 class="modal-title">Confirmation </h4>
           <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
         </div>
         <div class="modal-body">
          How to proceed ?
         </div>
         <div class="modal-footer">
           <button type="button" class="btn btn-sm" data-bs-dismiss="modal"
             (click)="saveonboard();isonboard=true;isreject=false;">Proceed with save</button>
           <button type="button" class="btn btn-sm" data-bs-dismiss="modal" (click)="dontsaveonboard();isonboard=true;isreject=false;" >Proceed without save</button>
         </div>
       </div>
     </div>
   </div>
      <!-- Close Modal -->
      <span id="openrejectModal" data-bs-target="#rejectModal" data-bs-toggle="modal"></span>
      <div class="modal" id="rejectModal" data-bs-backdrop="static">
        <div class="modal-dialog modal-md">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title">Confirmation </h4>
              <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
            </div>
            <div class="modal-body">
              How to proceed ?
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-sm" data-bs-dismiss="modal"
                (click)="savereject();isreject=true;isonboard=false">Proceed with save</button>
              <button type="button" class="btn btn-sm" data-bs-dismiss="modal" (click)="dontsavereject();isreject=true;isonboard=false" >Proceed without save</button>
            </div>
          </div>
        </div>
      </div>

  <span id="openSearchAddressModal" data-bs-target="#SearchAddress" data-bs-toggle="modal">
  </span>
  <div class="modal fade" id="SearchAddress" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog modal-xl" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="font-header">
            Search Address</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="AddressGoogleMap=false;"
            id="AddressGoogleMap"></button>
        </div>
        <div class="modal-body" style="min-height: 100px;">
          <div class="row">
            <div class="col-lg-12">
              <app-google-map *ngIf="AddressGoogleMap==true"
                (GoogleMapEmit)="EmitGoogleMapComponent($event)"></app-google-map>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary btn-sm" data-bs-dismiss="modal" id="AddressGoogleMapbtn"
            (click)="AddressGoogleMap=false">Close</button>
        </div>
      </div>
    </div>
  </div>
<!-- delete Modal -->
<span id="openReferalDelete" data-bs-toggle="modal" data-bs-target="#modalReferalDelete"></span>
<div class="modal fade" id="modalReferalDelete" data-bs-backdrop="static">
    <div class="modal-dialog modal-sm">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header" id="exampleModalLabel">
                    <span>Delete </span>
                </h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true"></span>
                </button>
            </div>
            <div class="modal-body">
                Are you sure you want to Delete?
            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn btn-sm" (click)="DeleteReferral()">Yes</button>
                <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal">No</button>
            </div>
        </div>
    </div>
</div>

  <!-- kendo Pdf Download -->

  <!-- Kendo PDF Download -->
  <div style="position: absolute; left: -1000px; top: 500px;">
    <kendo-pdf-export #pdfIntakeformList paperSize="A4">
      <div style="width: 700px;">
        <div *ngIf="ProspectiveCreate" class="card border-0 shadow">

          <!-- General Info Section -->
          <div class="card-header transparent text-muted ms-2 me-3 mt-2">
            <h5 class="mb-0 font-header-green">General Info</h5>
          </div>
          <div class="card-body widget-body pt-2 ms-2 me-3">
            <div class="row">
              <div class="col-md-6">
                <label class="fw-bold">First Name:</label> {{saveBo.firstName}}
              </div>
              <div class="col-md-6">
                <label class="fw-bold">Middle Name:</label> {{saveBo.middleName}}
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-md-6">
                <label class="fw-bold">Last Name:</label> {{saveBo.lastName}}
              </div>
              <div class="col-md-6">
                <label class="fw-bold">DOB:</label> {{saveBo.dOB}}
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-md-6">
                <label class="fw-bold">Gender:</label> {{genderfields}}
              </div>
              <div class="col-md-6">
                <label class="fw-bold">Age:</label> {{saveBo.age}}
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-md-6">
                <label class="fw-bold">Medicaid # (PMI):</label> {{saveBo.medicaid}}
              </div>
              <div class="col-md-6">
                <label class="fw-bold">Medicare #:</label> {{saveBo.medicare}}
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-md-6">
                <label class="fw-bold">Language:</label> {{languagefields}}
              </div>
              <div class="col-md-6">
                <label class="fw-bold">Type of Waiver:</label> {{waiverfield}}
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-md-6">
                <label class="fw-bold">Client Insurance ID:</label> {{saveBo.insuranceNo}}
              </div>
              <div class="col-md-6">
                <label class="fw-bold">CFSS Model:</label> {{saveBo.cfssModel}}
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-md-6">
                <label class="fw-bold">Pay Source:</label> {{paysourcfield}}
              </div>
              <div class="col-md-6">
                <label class="fw-bold">Client Type:</label> {{clienttype}}
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-md-6">
                <label class="fw-bold">Referral Date:</label> {{saveBo.referralStartTime}}
              </div>
              <div class="col-md-6">
                <label class="fw-bold">Location</label> {{locationfield}}
              </div>
            </div>
          </div>

          <!-- Contact Info Section -->
          <div class="card-header transparent text-muted ms-2 me-3">
            <h5 class="mb-0 font-header-green">Contact Info</h5>
          </div>
          <div class="card-body widget-body pt-2 ms-2 me-3">
            <div class="row">
              <div class="col-md-6">
                <label class="fw-bold">Email:</label> {{saveBo.email}}
              </div>
              <div class="col-md-6">
                <label class="fw-bold">Phone 1:</label> {{saveBo.phone1}}
              </div>
            </div>
            <div class="row mt-2">

              <div class="col-md-6">
                <label class="fw-bold">Phone 2:</label> {{saveBo.phone2}}
              </div>
              <div class="col-md-6">
                <label class="fw-bold">Street:</label> {{saveBo.street}}
              </div>
            </div>
            <div class="row mt-2">

              <div class="col-md-6">
                <label class="fw-bold">Apt:</label> {{saveBo.apt}}
              </div>
              <div class="col-md-6">
                <label class="fw-bold">City:</label> {{saveBo.city}}
              </div>
            </div>
            <div class="row mt-2">

              <div class="col-md-6">
                <label class="fw-bold">State:</label> {{saveBo.state}}
              </div>
              <div class="col-md-6">
                <label class="fw-bold">County:</label> {{saveBo.county}}
              </div>
            </div>
            <div class="row mt-2">

              <div class="col-md-6">
                <label class="fw-bold">ZIP Code:</label> {{saveBo.zipCode}}
              </div>
              
            </div>
            
          </div>

          <!-- Additional Notes Section -->
          <div class="card-header transparent text-muted ms-2 me-3">
            <h5 class="mb-0 font-header-green">Additional Notes</h5>
          </div>
          <div class="card-body widget-body pt-2 ms-2 me-3">
            <div class="row">
              <div class="col-md-6">
                <label class="fw-bold">Referrer Name:</label> {{saveBo.referer_Name}}
              </div>
              <div class="col-md-6">
                <label class="fw-bold">Referrer Phone:</label> {{saveBo.referer_PhoneNumber}}
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-md-6">
                <label class="fw-bold">Referrer Email:</label> {{saveBo.referer_Email}}
              </div>
              <div class="col-md-6">
                <label class="fw-bold">Last Assessment Date:</label> {{saveBo.lastAssessmentDate}}
              </div>
            </div>
          </div>
          <!-- Follow-up Notes -->
          <div class="card-header transparent text-muted mt-4">
            <h5 class="mb-0 font-header-green">Follow-Up Notes</h5>
          </div>
          <div class="card-body widget-body pt-2">
           {{saveBo.followUpNotes}}
          </div>
          <!-- <div class="card-header transparent text-muted mt-4" *ngIf="isrejectreason">
            <h5 class="mb-0 font-header-green">Reason For Rejection</h5>
          </div>
          <div class="card-body widget-body pt-2"*ngIf="isrejectreason">
           {{saveBo.reasonForRejection}}
          </div> -->
        </div>
      </div>
    </kendo-pdf-export>
  </div>

   <!-------------------------------Case Manger--------------------------------------------------------------->
   <span id="Caseopen" data-bs-toggle="modal" data-bs-target="#casemanager"></span>

   <div class="modal fade" id="casemanager" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true"
     data-bs-backdrop="static">
     <div class="modal-dialog modal-lg" [ngClass]="{'modal-xl': caseenable, '' : !caseenable}">
       <div class="modal-content">
         <div class="modal-header">
           <h5 class="modal-title font-header" id="exampleModalLabel" style="font-weight: 700;">Case Manager</h5>
           <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
             (click)="closecasemanager();caseenable=false;" id="closecasemanager"></button>
         </div>
         <div class="modal-body ml-1" [ngStyle]="caseenable == true ? {'height': '450px','overflow-y': 'auto'} : {}">
           <div class="row" *ngIf="!caseenable">
             <div class="col-lg-5">
               <label>Assign Case Manager<sup class="super-script">*</sup></label>
             </div>
             <div class="col-lg-7">
               <ng-select [(ngModel)]="assignCase.caseManagerId" [clearable]="false" [searchable]="true"
                 [items]="CaseManagerDropdownList" bindLabel="Value" bindValue="Key">
               </ng-select>
             </div>
           </div>
           <div class="row" *ngIf="!caseenable">
             <div class="col-lg-5">
               <label>Start Date<sup class="super-script ">&nbsp;*</sup></label>
             </div>
             <div class="col-lg-7">
               <my-date-picker [selDate]="assignCase.activeDate" [options]="myDatePickerOptions" placeholder="mm/dd/yyyy"
                 (inputFieldChanged)="newdatescontact($event,'inputchange','ActiveDate')"
                 (dateChanged)="newdatescontact($event,'datechanged','ActiveDate')">
               </my-date-picker>
             </div>
           </div>
           <div class="row" *ngIf="!caseenable">
             <div class="col-lg-5">
               <label class="labelpad">End Date</label>
             </div>
             <div class="col-lg-7">
               <my-date-picker [selDate]="assignCase.inActiveDate" [options]="myDatePickerOptions"
                 placeholder="mm/dd/yyyy" (inputFieldChanged)="newdatescontact($event,'inputchange','InActiveDate')"
                 [disabled]="assignCase.activeDate==null||assignCase.activeDate==undefined||assignCase.activeDate==''"
                 (dateChanged)="newdatescontact($event,'datechanged','InActiveDate')">
               </my-date-picker>
             </div>
           </div>
           <div class="row mt-1">
             <div class="col-lg-12">
               <app-case-manager *ngIf="caseenable" (emitcasemanger)="evenfromcase($event)" [fromClient]="casetype">
               </app-case-manager>
             </div>
           </div>
         </div>
         <div class="modal-footer">
           <button type="button" class="btn btn-sm btn-primary" (click)="AssignCase()" id="AssignCase"
             [disabled]="assignCase.caseManagerId == '00000000-0000-0000-0000-000000000000'|| this.assignCase.caseManagerId==undefined||this.assignCase.caseManagerId==null||this.assignCase.caseManagerId==0||this.assignCase.activeDate==undefined||this.assignCase.activeDate==null||this.assignCase.activeDate==''"
             *ngIf="!(this.assignCase.id!=undefined&&this.assignCase.id!=null&&assignCase.id != '00000000-0000-0000-0000-000000000000')&&!caseenable">
             Assign
           </button>
           <button type="button" class="btn btn-sm btn-primary" id="updateCase"
             *ngIf="!caseenable&&this.assignCase.id!=undefined&&this.assignCase.id!=null&&assignCase.id != '00000000-0000-0000-0000-000000000000'"
             [disabled]="(this.assignCase.caseManagerId==undefined||this.assignCase.caseManagerId==null||this.assignCase.caseManagerId==0||assignCase.caseManagerId == '00000000-0000-0000-0000-000000000000'||this.assignCase.activeDate==undefined||this.assignCase.activeDate==null||this.assignCase.activeDate=='')"
             (click)="AssignCase()">
             Update
           </button>
           <button type="button" class="btn btn-sm btn-secondary" id="closeCase"
             (click)="caseenable = false; closecase()">
             Cancel
           </button>
         </div>
       </div>
     </div>
   </div>
 
   <!--------------- delete case manager------------------ -->
 
   <span id="deletecasemanger" data-bs-toggle="modal" data-bs-target="#deletecase"></span>
   <div class="modal hide fade modalbackgrod" id="deletecase" tabindex="-1" aria-labelledby="exampleModalLabel"
     aria-hidden="true" data-bs-backdrop="static">
     <div class="modal-dialog  ">
       <div class="modal-content">
         <div class="modal-header">
           <h5 class="modal-title font-header" id="exampleModalLabel">Delete Record</h5>
           <button type="button" class="btn-close" data-bs-dismiss="modal" id="deleteCaseicon"></button>
         </div>
         <div class="modal-body ">
           Do you want to delete this record ?
         </div>
         <div class="modal-footer">
           <button type="button" class="btn btn-sm btn-primary" (click)="deleteCase()" id="deleteCase">Yes</button>
           <button type="button" class="btn btn-sm btn-primary" data-bs-dismiss="modal" id="deleteCaseno">No</button>
         </div>
       </div>
     </div>
   </div>
 
 
   <!-------------------------------------------Delete care coordinator------------------------------------------------------------>
   <span id="deletecarecoordinator" data-bs-toggle="modal" data-bs-target="#deletecare"></span>
   <div class="modal hide fade modalbackgrod" id="deletecare" tabindex="-1" aria-labelledby="exampleModalLabel"
     aria-hidden="true" data-bs-backdrop="static">
     <div class="modal-dialog ">
       <div class="modal-content">
         <div class="modal-header">
           <h5 class="modal-title font-header" id="exampleModalLabel">Delete Record</h5>
           <button type="button" class="btn-close" data-bs-dismiss="modal" id="deleterecord"></button>
 
         </div>
         <div class="modal-body ">
           Do you want to delete this record ?
         </div>
         <div class="modal-footer">
           <button type="button" class="btn btn-sm btn-primary" (click)="deleteCeare()" id="deleteCeare">Yes</button>
 
           <button type="button" class="btn btn-sm btn-primary" data-bs-dismiss="modal" id="deleteCeareno">No</button>
         </div>
       </div>
     </div>
   </div>
 
   <!------------------care coordinator---------------------------------------------------------------------->
   <span id="Careopen" data-bs-toggle="modal" data-bs-target="#carecoordinator"></span>
   <div class="modal hide fade modalbackgrod" id="carecoordinator" tabindex="-1" aria-labelledby="exampleModalLabel"
     aria-hidden="true" data-bs-backdrop="static">
     <div class="modal-dialog modal-lg" [ngClass]="{'modal-xl': careenable, '': !careenable}">
       <div class="modal-content">
         <div class="modal-header">
 
           <h5 class="modal-title font-header" id="exampleModalLabel" style="font-weight: 700;">Care Coordinator</h5>
           <button type="button" class="btn-close" (click)="closecarecoordinator();careenable=false;"
             id="closecarecoordinator"></button>
 
         </div>
 
         <div class="modal-body ml-1" [ngStyle]="careenable==true?{'height': '450px','overflow-y': 'auto'}:{}">
           <div class="row" *ngIf="!careenable">
             <div class="col-lg-5">
               <label style="font-weight: 530;">Assign Care Coordinator<sup class="super-script">*</sup></label>
 
             </div>
             <div class="col-lg-7">
               <ng-select [(ngModel)]="assignCare.careCoordinatorId" [clearable]="false" [searchable]="true"
                 [items]="CareCoordinatorDropdownList" bindLabel="Value" bindValue="Key">
               </ng-select>
             </div>
           </div>
           <div class="row" *ngIf="!careenable">
             <div class="col-lg-5">
               <label>Start Date<sup class="super-script ">&nbsp;*</sup></label>
             </div>
             <div class="col-lg-7">
               <my-date-picker [selDate]="assignCare.activeDate" [options]="myDatePickerOptions" placeholder="mm/dd/yyyy"
                 (inputFieldChanged)="newdatescontact($event,'inputchange','CareActiveDate')"
                 (dateChanged)="newdatescontact($event,'datechanged','CareActiveDate')">
               </my-date-picker>
             </div>
           </div>
           <div class="row" *ngIf="!careenable">
             <div class="col-lg-5">
               <label class="labelpad">
                 End Date
               </label>
             </div>
             <div class="col-lg-7">
               <my-date-picker [selDate]="assignCare.inActiveDate" [options]="myDatePickerOptions"
                 placeholder="mm/dd/yyyy" (inputFieldChanged)="newdatescontact($event,'inputchange','CareInActiveDate')"
                 [disabled]="(assignCare.activeDate==null||assignCare.activeDate==undefined||assignCare.activeDate=='')"
                 (dateChanged)="newdatescontact($event,'datechanged','CareInActiveDate')">
               </my-date-picker>
             </div>
           </div>
 
           <div class="row">
             <div class="col-lg-12">
               <app-care-coordinator *ngIf="careenable" (emitcarecode)="evenfromcare($event)" [fromClient]="caretype">
               </app-care-coordinator>
             </div>
           </div>
         </div>
         <div class="modal-footer">
           <button type="button" class="btn btn-sm btn-primary" (click)="AssignCare()" id="AssignCare"
             [disabled]="(this.assignCare.careCoordinatorId==undefined||this.assignCare.careCoordinatorId==null||this.assignCare.careCoordinatorId==0||this.assignCare.activeDate==undefined||this.assignCare.activeDate==null||this.assignCare.activeDate=='')"
             *ngIf="!careenable&&!(this.assignCare?.id!=undefined&&this.assignCare?.id!=null&&this.assignCare?.id!=0)">Assign</button>
           <button type="button" class="btn btn-sm btn-primary" id="updateCare"
             *ngIf="!careenable&&this.assignCare?.id!=undefined&&this.assignCare?.id!=null&&this.assignCare?.id!=0"
             (click)="AssignCare()"
             [disabled]="(this.assignCare.careCoordinatorId==undefined||this.assignCare.careCoordinatorId==null||this.assignCare.careCoordinatorId==0||this.assignCare.activeDate==undefined||this.assignCare.activeDate==null||this.assignCare.activeDate=='')">Update</button>
 
           <button type="button" class="btn btn-sm btn-primary" (click)="careenable=false;" id="closeCare"
             data-bs-dismiss="modal">Cancel</button>
         </div>
       </div>
     </div>
   </div>

   <!-- Error Delete Modal -->
<span id="openDeleteErrorModal" data-bs-target="#errordeletemodal" data-bs-toggle="modal"></span>
<div class="modal fade" id="errordeletemodal" data-bs-backdrop="static" tabindex="-1">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-header">Unable to Delete</h5>
        <button type="button" class="btn-close" aria-label="Close" data-bs-dismiss="modal" id="ClientListnoteicon"></button>
      </div>
      <div class="modal-body">
        <div class="row ms-3">
          <div class="col-lg-12">
            <label class="text-danger">This Client has</label>
          </div>
        </div>
        <div class="row ms-5">
          <div class="col-lg-12 ms-5">
            <div *ngFor="let err of deleteError">
              <ul class="mb-0 ms-4">
                <li class="text-danger">{{err}}</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary btn-sm" data-bs-dismiss="modal" id="ClientListnoteok">Ok</button>
      </div>
    </div>
  </div>
</div>

  
